export default function Alert({ children, className = "" }) {
    return (
        <div
            className={`bg-bgLight dark:bg-bgDark-300 p-5 rounded-xl mb-5 ${className}`}
        >
            <div className="text-[#05060F]/70 dark:text-lightBlue flex gap-4 items-center">
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-blue-500"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10"
                            opacity=".5"
                        ></path>
                        <path
                            fill="currentColor"
                            d="M12 17.75a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75M12 7a1 1 0 1 1 0 2a1 1 0 0 1 0-2"
                        ></path>
                    </svg>
                </div>
                {children}
            </div>
        </div>
    );
}
